/*
*  Site-wide content. Copy is word-for-word from the original Wix site (www.estia-events.com) - check with the client before rewording.
*  The event pages (Weddings, Birthdays etc.) are in pages.js
*/

export const SITE_NAME = "Estia Venue & Events";
export const SITE_URL = "https://www.estia-events.com";
export const DEFAULT_DESCRIPTION = "Melrose & Houghton Estate’s most sought after event venues. Our exquisite event venues are the ultimate setting for any event. Coupled with our tailored approach to event coordination and attention to detail, we ensure planning your next event is a dream.";

//The Wix page addresses are kept, so existing links and Google results keep working
export const ROUTES = {
  HOME: "/",
  ABOUT: "/about-us",
  WEDDINGS: "/weddings-receptions",
  DESTINATION_WEDDINGS: "/destination-weddings",
  ENGAGEMENT_PARTIES: "/engagement-parties",
  BRIDAL_SHOWERS: "/bridal-showers",
  YEAR_END_FUNCTIONS: "/year-end-functions",
  PRODUCT_LAUNCHES: "/product-launches",
  FUNCTIONS_OCCASIONS: "/functions-occasions",
  BIRTHDAYS: "/birthdays",
  CHRISTENINGS: "/christenings",
  HIGH_TEAS: "/high-teas",
  BABY_SHOWERS: "/baby-showers",
  CONFERENCES: "/conferences",
  DECOR_HIRE: "/decor-hire",
  TRAVEL: "/travel",
  CONTACT: "/contact",
  PRIVACY: "/privacy-policy",
};

//Our-Venue event builder / quote tool (opens in a new tab)
export const QUOTE_LINK = "https://estiaevents.our-venue.com/";

//"children" makes a drop-down, as on Wix
export const NAV_LINKS = [
  { label: "About", path: ROUTES.ABOUT },
  {
    label: "Weddings",
    children: [
      { label: "Weddings & Receptions", path: ROUTES.WEDDINGS },
      { label: "Destination Weddings", path: ROUTES.DESTINATION_WEDDINGS },
      { label: "Engagement Parties", path: ROUTES.ENGAGEMENT_PARTIES },
      { label: "Bridal Showers", path: ROUTES.BRIDAL_SHOWERS },
      { label: "Get Quote", href: QUOTE_LINK },
    ],
  },
  {
    label: "Functions",
    children: [
      { label: "Year-End Functions", path: ROUTES.YEAR_END_FUNCTIONS },
      { label: "Product Launches", path: ROUTES.PRODUCT_LAUNCHES },
      { label: "Functions & Occasions", path: ROUTES.FUNCTIONS_OCCASIONS },
      { label: "Birthdays", path: ROUTES.BIRTHDAYS },
      { label: "Christenings", path: ROUTES.CHRISTENINGS },
      { label: "Get Quote", href: QUOTE_LINK },
    ],
  },
  { label: "Decor Hire", path: ROUTES.DECOR_HIRE },
  { label: "Travel", path: ROUTES.TRAVEL },
  { label: "Contact", path: ROUTES.CONTACT },
  { label: "Get Quote", href: QUOTE_LINK },
];

export const CONTACT_DETAILS = {
  LANDLINE: { label: "076 777 7777", header: "(076) 777 7777", link: "tel:+27767777777" },
  CELL: { label: "084 883 7757", link: "tel:+27848837757" },
  WHATSAPP_LINK: "https://wa.me/27848837757",
  EMAIL: "bookings@estiaevents.co.za",
  ADDRESS: ["60 5th St,", "Houghton Estate,", "Johannesburg, 2198"],
  MAP_LINK: "https://g.page/estia-events-venue?share",
  //Google map in the footer (on the laptop screen, as on Wix) - pinned to the same spot as the Wix map
  MAP_EMBED: "https://maps.google.com/maps?q=-26.143073,28.053924&z=15&hl=en&output=embed",
  FACEBOOK_LINK: "https://www.facebook.com/EstiaVenue/",
  INSTAGRAM_LINK: "https://www.instagram.com/estiavenue/",
};

//Footer badges (link to the listings, as on Wix)
export const BADGES = [
  { src: "/images/badges/top-reviews.png", width: 270, height: 270, alt: "Top Reviews - best event spaces in Johannesburg", link: "https://www.topreviews.co.za/best-event-spaces-johannesburg/" },
  { src: "/images/badges/proudly-sa-weddings.png", width: 240, height: 246, alt: "Proudly SA Weddings", link: "https://www.saweddings.co.za/venues-1/wedding-venues-5/estia-events-venue" },
  { src: "/images/badges/our-venue-award.png", width: 500, height: 475, alt: "Our-Venue.com Spotlight of Recognition Awards winner", link: "https://our-venue.com/All-Venues/Visit/Estia-Venues-Events", isWide: true },
];

export const POLICY_LINKS = [
  { label: "VIEW OUR REFUND POLICY", href: "/files/estia-refund-policy.pdf" },
  { label: "VIEW OUR T&C's", href: "/files/estia-terms-and-conditions.pdf" },
  { label: "VIEW OUR PRIVACY POLICY", path: ROUTES.PRIVACY },
];

export const CREDIT = { label: "TapX.", link: "https://www.tap-x.com/" };

/*
*  Popup shown on the home page a few seconds after it opens (a Wix "lightbox" on the old site).
*  To change it: put the new poster in public/images/popup and update IMAGE / WIDTH / HEIGHT / ALT / LINK and ID.
*  To switch it off: ENABLED: false.
*  SHOW_UNTIL (optional, "YYYY-MM-DD"): the popup stops showing after this date, so a past event doesn't linger.
*/
export const POPUP = {
  ENABLED: true,
  ID: "estia-collection-october-2026", //Change when the poster changes, so visitors who closed the old one see the new one
  IMAGE: "/images/popup/estia-collection-october-2026.webp",
  WIDTH: 1031,
  HEIGHT: 691,
  //Clicking the poster opens this page in a new tab, as on Wix (leave empty for no link)
  LINK: "https://showcase.estia-events.com/events",
  LINK_LABEL: "Book your experience",
  //The poster is a picture of text, so the alt text carries the details for screen readers
  ALT: "The Estia Collection - Proudly South African Edition. A celebration of our heritage, our people and our beautiful country. 23 October 2026, 62 5th Street, Melrose Estate, Johannesburg, 2196. Book your experience. Beautiful settings, delicious food, unforgettable moments. Honouring our roots, celebrating our future. Invite-only open day: inspiration, connections, celebration. Be part of it.",
  LABEL: "The Estia Collection - Proudly South African Edition, 23 October 2026",
  SHOW_UNTIL: "2026-10-23",
  DELAY_MS: 2500,
};

//Home page slideshow
export const SLIDESHOW = [
  { src: "/images/slides/slide-1.webp", width: 1920, height: 1280, alt: "A reception table with a floral centrepiece at Estia" },
  { src: "/images/slides/slide-2.webp", width: 1536, height: 1024, alt: "The Estia Crystal Room set for an event" },
  { src: "/images/slides/slide-3.webp", width: 1920, height: 1280, alt: "Tables set for an event at Estia" },
  { src: "/images/slides/slide-4.webp", width: 1536, height: 1024, alt: "The Estia Crystal Room with chandeliers" },
];

//3D tour of the Crystal Room on the home page
export const TOUR_LINK = "https://my.matterport.com/show/?m=YQSZ5R4LEok";
